/**
 * Accessibility settings (persisted to localStorage), applied globally:
 *
 *  • reduceMotion — cuts particle density and skips the barrier-flash panel;
 *    read by Effects and the hub veins so heavy/repetitive motion is toned down.
 *  • colorblind   — swaps the rarity palette for a set chosen to stay distinct
 *    across common colour-vision deficiencies (distinct hue AND luminance).
 *
 * The rarity swap MUTATES RARITY[i].color in place rather than replacing the
 * objects, so item.rarity identity is preserved (RARITY.indexOf / rehydrate keep
 * working) and every `it.rarity.color` read picks up the new colour for free.
 */
import { RARITY } from "../config/constants.js";

const KEY_MOTION = "relikara.a11y.reduceMotion";
const KEY_CB = "relikara.a11y.colorblind";

// snapshot the authored colours, and a colour-vision-deficiency-safe alternate.
// Common→light grey, Uncommon→teal, Rare→blue, Epic→magenta, Legendary→amber.
const RARITY_DEFAULT = RARITY.map((r) => r.color);
const RARITY_CB = ["#dcdcdc", "#00b3a4", "#2b7fff", "#e36bff", "#ffb000"];

export const A11Y = { reduceMotion: false, colorblind: false };

function readBool(k) { try { return localStorage.getItem(k) === "1"; } catch (_) { return false; } }
function writeBool(k, v) { try { localStorage.setItem(k, v ? "1" : "0"); } catch (_) {} }

export function applyReduceMotion(on) {
  A11Y.reduceMotion = !!on;
  document.documentElement.setAttribute("data-reduce-motion", on ? "1" : "0");
}
export function applyColorblind(on) {
  A11Y.colorblind = !!on;
  const src = on ? RARITY_CB : RARITY_DEFAULT;
  for (let i = 0; i < RARITY.length; i++) if (src[i]) RARITY[i].color = src[i];
  document.documentElement.setAttribute("data-cb", on ? "1" : "0");
}

export function setReduceMotion(on) { applyReduceMotion(on); writeBool(KEY_MOTION, on); }
export function setColorblind(on) { applyColorblind(on); writeBool(KEY_CB, on); }

/** Apply saved accessibility prefs before the game builds anything. */
export function initA11y() {
  applyReduceMotion(readBool(KEY_MOTION));
  applyColorblind(readBool(KEY_CB));
}
